<template>
    <div class='item-uploadImage'>
        <div class='deletes' v-if='imageUrl' @click="deleteUrl">
            <i class="el-icon-error"></i>
        </div>
        <div class='uploadImage'>
            <el-upload
                style="width: 200px"
                class="uploader"
                action=""
                :show-file-list="false"
                :http-request="uploadImage"
            >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" size="small" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </div>
    </div>



</template>

<script>
import { upload } from '@/utils/request';
import { UPLOAD_PATH } from '@/utils/constant';

export default {
    props:{
        imageUrl:{
            type:String,
            default:''
        }
    },
    data() {
        return {

        }
    },
    methods: {
        uploadImage(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.$emit('updateUrl',res.url)
                }
            });
        },
        deleteUrl(){
            this.$emit('deleteUrl');
        },
    }
};
</script>

<style lang='scss' scoped>

.item-uploadImage{
    position: relative;
    padding: 10px 0;
    .deletes{
        position: absolute;
        top: -5px;
        left: 55px;
        width: 15px;
        height: 15px;
        z-index: 1;
        font-size: 24px;
    }
}

.uploadImage {
    width: 70px;
    height: 70px;
    background-color: #eee;
    ::v-deep .el-upload {
        width: 70px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    img {
        width: 100%;
        height: 100%;
    }
}
</style>